import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

type Props = {
  children: React.ReactNode;
  /** When true, this route doesn't require a pillar (e.g. /onboarding). */
  allowWithoutPillar?: boolean;
};

export const ProtectedRoute = ({ children, allowWithoutPillar = false }: Props) => {
  const { user, loading, profile, profileLoading } = useAuth();
  const location = useLocation();

  if (loading || (user && !profile && profileLoading)) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  if (!profile?.selected_pillar && !allowWithoutPillar) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
};
